import { CustomFieldValidators } from '@tribeplatform/gql-client/types'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'

import { Form } from '../../Form/index.js'

export const ArrayInput = ({ field, name, onChange, value, extraProps }) => {
  if (field?.items?.validators?.length) {
    const enumValidator = field?.items?.validators?.find(
      validator => validator.validation === CustomFieldValidators.enum,
    )

    if (enumValidator?.value) {
      try {
        const validValues = JSON.parse(enumValidator.value) as string[]
        if (extraProps?.label) {
          return (
            <Form.Multiselect
              name={name}
              onChange={value => {
                if (typeof onChange === 'function') {
                  onChange([value])
                }
              }}
              options={validValues}
              {...extraProps}
            />
          )
        }

        const { labels = {} } = field
        return (
          <Dropdown>
            <Dropdown.Button>{labels[value] ?? value}</Dropdown.Button>
            <Dropdown.Items>
              {validValues.map(value => (
                <Dropdown.Item
                  key={value}
                  onClick={() => {
                    if (typeof onChange === 'function') {
                      onChange(value)
                    }
                  }}
                >
                  {labels[value] ?? value}
                </Dropdown.Item>
              ))}
            </Dropdown.Items>
          </Dropdown>
        )
      } catch (e) {
        console.error('Could not parse enum array custom field validator')
      }
    }
  }
  return null
}
